<div class="no-result fw-500">{{ message }}</div>
